var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 2.93 10.408 13.593M3.27 8.235l16.606-5.761c1.023-.355 2.004.626 1.65 1.649l-5.762 16.606c-.395 1.137-1.992 1.169-2.43.047l-2.638-6.739a1.296 1.296 0 0 0-.734-.734l-6.739-2.637c-1.121-.439-1.09-2.036.047-2.43Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendOutlineIcon);
export default __webpack_public_path__ + "static/media/send-outline-icon.aa18396237bf7ab1f5b3102e31b67c66.svg";
export { ForwardRef as ReactComponent };